import { Link } from "react-router";
import { PhotoView } from "react-photo-view";
import { galleryImages } from "../data/galleryData";

export default function GalleryPreview() {
  const previewImages = galleryImages.slice(0, 12);

  return (
    <section className="gallery-preview" id="gallery">
      <div className="container">
        <p className="eyebrow center">Captured Moments</p>

        <h2 className="section-title center">A Glimpse Of Our Celebrations</h2>

        <p className="section-sub center">
          Every celebration tells a unique story. Here's a glimpse into the
          unforgettable moments we've had the honor of creating.
        </p>

        <div className="gallery-grid">
          {galleryImages.map((photo) => (
            <PhotoView key={photo.id} src={photo.image}>
              <div className="gallery-card">
                <img
                  src={photo.image}
                  alt={`Gallery ${photo.id}`}
                  loading="lazy"
                />
              </div>
            </PhotoView>
          ))}
        </div>
      </div>
    </section>
  );
}
